import { observer } from "mobx-react-lite";

import { useNewCategoryModalState } from "./modal.state";
import { NewCategoryModalView } from "./modal.view";

export const NewCategoryModal = observer(() => {
  const state = useNewCategoryModalState();
  return <NewCategoryModalView state={state} />;
});
